import { useMutation } from "@tanstack/react-query";

import localStorageKey from "../../../enumerations/localStorageKey";
import {
  apiGetUserForgetSendVerify,
  apiPostUserMailSend,
  apiPostUserMailVerify,
  apiPutUserForgetPassword,
} from "../service";

const CURRENCY =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;

export const usePostEmailSend = (options) => {
  return useMutation(
    (params) =>
      apiPostUserMailSend(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
    },
  );
};
export const useGetUserForgetSendVerify = () => {
  return useMutation(
    (params) =>
      apiGetUserForgetSendVerify(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
    },
  );
};
export const usePostEmailVerify = (options = { onSuccess: () => {} }) => {
  return useMutation(
    (params) =>
      apiPostUserMailVerify(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
      onSuccess: options.onSuccess,
    },
  );
};

export const usePutForgetPassword = (options = { onSuccess: () => {} }) => {
  return useMutation(
    (params) =>
      apiPutUserForgetPassword(params).then((res) => {
        return res.data.data;
      }),
    {
      onError: (error) => {
        console.debug(JSON.stringify("ERR", error));
      },
      onSuccess: options.onSuccess,
    },
  );
};
